export default __webpack_public_path__ + "static/5-adca0c68d7c4cae67de201dfd67521aa.svg";